import { useLayoutEffect } from 'react'
import { Cohort } from 'root-constants'
import { useZustandStore } from 'zustandGlobalStore'

const PROD_PIXEL_ID_INTL_1 = '1122838853306559'
const PROD_PIXEL_ID_INTL_2 = '26875161555484849'
const DEV_PIXEL_ID = '983717727567905'

export const useFacebookPixelInitialization = (): void => {
  const leadId = useZustandStore((state) => state.lead?.id)
  const cohort = useZustandStore((state) => state.lead?.cohort)

  const currentFacebookPixelId =
    import.meta.env.CURRENT_ENV === 'prod'
      ? cohort === Cohort.INTL_2 ||
        cohort === Cohort.INTL_2LW ||
        cohort === Cohort.INTL_D60 ||
        cohort === Cohort.INTL_D70 ||
        cohort === Cohort.INTL_HLWN70 ||
        cohort === Cohort.INTL_MW ||
        cohort === Cohort.INTL_3
        ? PROD_PIXEL_ID_INTL_2
        : PROD_PIXEL_ID_INTL_1
      : DEV_PIXEL_ID

  useLayoutEffect(() => {
    if (!cohort) return
    window.fbq('init', currentFacebookPixelId, { external_id: leadId })
    window.fbq('track', 'PageView')
  }, [currentFacebookPixelId, leadId, cohort])
}
